import { useMutation, useQuery } from '@apollo/client';
import { SetSettingsResult } from '@eti/schema-types';
import { useEffect, useState } from 'react';
import { withSubSessionParam } from '../../../subSession/withSubSessionParam';
import { withStoredUtmParams } from '../../../utils/redirects';
import { GET_SETTINGS } from '../queries';
import { SET_SETTINGS } from '../mutations';
import Settings from './Settings';
import SettingsSkeleton from './SettingsSkeleton';

type OptionType = {
  value: string;
  label: string;
};
const SettingsGraphqlContainer = ({
  iconOnly = false,
  componentType = 'Menu',
}: {
  iconOnly?: boolean;
  componentType?: 'Header' | 'Footer' | 'Menu';
}) => {
  useEffect(() => {
    const url = new URL(window.location.href);
    url.searchParams.delete('customerLanguage');
    window.history.replaceState(null, '', withSubSessionParam(url.toString()));
  }, []);

  const { data, loading } = useQuery(GET_SETTINGS);
  const [setSettings] = useMutation(SET_SETTINGS);
  const [isSaving, setIsSaving] = useState(false);
  if (loading) {
    return <SettingsSkeleton iconOnly={iconOnly} />;
  }

  if (!data) {
    return null;
  }

  const handleOnSubmit = async (
    selectedLocaleOption: OptionType,
    selectedRegionOption: OptionType,
    selectedCurrencyOption: OptionType,
  ) => {
    setIsSaving(true);
    try {
      const { data: setData } = await setSettings({
        variables: {
          localeCode: selectedLocaleOption.value,
          regionCode: selectedRegionOption.value,
          currencyCode: selectedCurrencyOption?.value,
        },
      });

      if (setData?.setSettings?.result === SetSettingsResult.Success) {
        window.location.reload();
      } else if (setData?.setSettings?.redirectUrl) {
        window.location.assign(
          withSubSessionParam(withStoredUtmParams(setData.setSettings.redirectUrl), {
            isBackendUrl: true,
          }),
        );
      } else {
        setIsSaving(false);
      }
    } catch (error) {
      setIsSaving(false);
      // oxlint-disable-next-line no-console
      console.error(error);
    }
  };

  return (
    <Settings
      componentType={componentType}
      iconOnly={iconOnly}
      isSaving={isSaving}
      onSubmit={handleOnSubmit}
      settings={data?.settings}
    />
  );
};

export default SettingsGraphqlContainer;
